import moment from "moment";
import numeral from 'numeral';
import { useCallback, useContext, useMemo, useState } from 'react';
import { ProgressBar } from 'react-bootstrap-v5';
import { useQuery } from 'react-query';
import { PageTitle } from '../../../../_metronic/layout/core';
import * as Api from '../../../api/Api';
import { GetGarantiasByEstadoCuenta } from "../../../api/Api";
import { SessionContext } from '../../../Components/Context/SessionContext';
import WrappedAgTable from '../../../Components/Table/WrappedAgTable';
import * as Utilities from '../../../Components/Utils/Utils';
import { useGetToken } from '../../../Hooks/CustomHooks';
import DetalleDeuda from "../../UserMall/Modulos/DetalleDeuda";
import '../Dashboard/Dashboard.css';

export default function EstadoCuenta_Locatario({ title }) {
    const { session, setSession } = useContext(SessionContext);
    const token = useGetToken();
    const [showDetalleDeuda, setShowDetalleDeuda] = useState(false);
    const [idDeudaCurrentDetalle, setIdDeudaCurrentDetalle] = useState(null);

    const { data: dataDetalleEstadoCuenta } = useQuery(
        'detalleEstadoCuenta',
        () =>
            Api.DetalleEstadoCuenta({
                ruc: session?.ruc,
                token: token,
            })
    )
    const { data: deudasVencidasList } = useQuery(
        'getlistaDeudasVencidas',
        () =>
            Api.GetlistaDeudasVencidas({
                ruc: session?.ruc,
                token: token,
            })
    )
    const { data: cobranzaIndicadoresLista } = useQuery(
        'getlistaCobranzaIndicadores',
        () =>
            Api.GetlistaCobranzaIndicadores({
                ruc: session?.ruc,
                token: token,
            })
    )

    const { data: dataCuentaRecaudadora } = useQuery(
        'dataCuentaRecaudadoraList',
        () =>
            Api.GetCuentasRecaudadoras({
                ruc: session?.ruc,
                token: token,
            })
    )


    /*Garantias Estado de Cuenta*/
    const { data: garantiasByEstadoCuentaList } = useQuery("getGarantiasByEstadoCuenta", () => GetGarantiasByEstadoCuenta(session?.ruc));
    const headerListaGarantiasByEstadoCuenta = useMemo(() => [
        {
            headerName: 'Nro.Carta Fianza',
            field: 'nroCartaFianza',
            width: 140,
            filter: 'agTextColumnFilter',
            cellRenderer: (props) => {
                if (!props.data) {
                    return <></>;
                }
                return <a href={props.data.urlFileNameCartaFianza} className="link-custom-blue d-flex align-items-center mx-2" target="_blank" rel="noreferrer">
                    <span>{props.data.nroCartaFianza}</span>
                </a>;
            }
        },
        {
            headerName: 'Moneda',
            field: 'codigoMoneda',
            width: 90,
        },
        {
            headerName: 'Importe',
            field: 'importe',
            type: 'rightAligned',
            width: 100,
            filter: 'agTextColumnFilter',
            valueFormatter: function (params) {
                return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
            },
        },
        {
            headerName: 'Interés',
            field: 'intereses',
            type: 'rightAligned',
            width: 100,
            filter: 'agTextColumnFilter',
            valueFormatter: function (params) {
                return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
            },
        },
        {
            headerName: 'Importe Final',
            field: 'importeFinal',
            type: 'rightAligned',
            width: 130,
            valueFormatter: function (params) {
                return params.value ? `${numeral(params.value).format('0,0.00')}` : ``;
            },
        },
        {
            headerName: 'Banco',
            field: 'codigoBanco',
            width: 120,
        },
        {
            headerName: 'Mall',
            field: 'nombreMall',
        },
        {
            headerName: 'Fec.Emision C.Fianza',
            field: 'fechaEmisionCartaFianza',
            width: 160,
            filter: 'agDateColumnFilter',
            filterParams: Utilities.createCustomDateFilterParams,
            valueFormatter: function (params) {
                return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
            },
        },
        {
            headerName: 'Fec.Venc. C.Fianza',
            field: 'fechaVencimientoCartaFianza',
            width: 160,
            filter: 'agDateColumnFilter',
            filterParams: Utilities.createCustomDateFilterParams,
            valueFormatter: function (params) {
                return (params.value) ? `${moment(params.value).format("DD/MM/yyyy")}` : null;
            },
        },
        {
            headerName: 'Origen',
            field: 'origen',
            width: 120,
        }
    ], []);
    const agGridListaGarantiasByEstadoCuenta = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: headerListaGarantiasByEstadoCuenta,
        rowData: garantiasByEstadoCuentaList?.data || [],
        pagination: false,
        //rowGroupPanelShow: 'always',
        // autoGroupColumnDef: {
        //     headerName: 'Grupo',
        //     filter: 'agGroupColumnFilter'
        // }

    }), [headerListaGarantiasByEstadoCuenta, garantiasByEstadoCuentaList?.data]);
    /* END - Garantias Estado de Cuenta */

    const headerCobranzaList = useMemo(() => [
        {
            headerName: 'Contrato ',
            field: 'codigoContrato',
            width: 90,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'DSO',
            field: 'dso',
            width: 80,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: '% CxC',
            field: 'porcentajeCxC',
            width: 90,
            filter: 'agTextColumnFilter',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.porcentajeCxC, true)}%</>
            )
        },
        {
            headerName: 'Efic. Cob',
            field: 'eficienciaCobranza',
            width: 90,
            filter: 'agTextColumnFilter',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.eficienciaCobranza, true)}%</>
            )
        },
        {
            headerName: 'Moneda',
            field: 'moneda',
            width: 90,
        }
    ], []);

    const agGridCobranzaList = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: headerCobranzaList,
        rowData: cobranzaIndicadoresLista?.data.table || [],
        pagination: true,
        rowGroupPanelShow: 'always',
        autoGroupColumnDef: {
            headerName: 'Grupo',
            filter: 'agGroupColumnFilter'
        },
        autoSizeColumns: true,
    }), [headerCobranzaList, cobranzaIndicadoresLista?.data]);


    const headerListaDeudasVencidas = useMemo(() => [
        {
            headerName: 'Mall',
            field: 'mall',
        },
        {
            headerName: 'Nro Contrato',
            field: 'numeroContrato',
            width: 120,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Cliente',
            field: 'cliente',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Tipo doc',
            field: 'tipoDoc',
            width: 150,
        },
        {
            headerName: 'Referencia',
            field: 'referencia',
            width: 150,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Texto',
            field: 'texto',
            width: 150,
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Fecha de Emisión',
            field: 'fechaEmision',
            width: 150,
            filter: 'agDateColumnFilter',
            filterParams: Utilities.createCustomDateStringFilterParams,
        },
        {
            headerName: 'Fecha de Pago',
            field: 'fechaPago',
            width: 150,
            filter: 'agDateColumnFilter',
            filterParams: Utilities.createCustomDateStringFilterParams,
        },
        {
            headerName: 'Importe',
            field: 'importe',
            width: 140,
            filter: 'agTextColumnFilter',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.importe, true)}</>
            )
        },
        {
            headerName: 'Atraso',
            field: 'atrasoDias',
            width: 120,
            filter: 'agTextColumnFilter',
            cellRenderer: (props) => (
                <>{props.data.atrasoDias} días</>
            )
        },
        {
            headerName: 'Detalle',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={() => {
                    setIdDeudaCurrentDetalle(props.data.idDeuda);
                    setShowDetalleDeuda(true);
                }}>
                    <i className="fi-rr-interactive"></i>
                </button >
            )
        }
    ], []);

    const agGridDeudasVencidasList = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: headerListaDeudasVencidas,
        rowData: deudasVencidasList?.data?.table || [],
        pagination: true,
        rowGroupPanelShow: 'always',
        autoGroupColumnDef: {
            headerName: 'Grupo',
            filter: 'agGroupColumnFilter'
        },
        autoSizeColumns: true,
    }), [headerListaDeudasVencidas, deudasVencidasList?.data]);

    const headerListaCuentasRecaudadoras = useMemo(() => [
        {
            headerName: 'Entidad',
            field: 'entidad',
        },
        {
            headerName: 'Tipo de Cuenta',
            field: 'tipoCuenta',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Cuenta S/',
            field: 'cuentaSoles',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'CCI Cuenta S/',
            field: 'cciCuentaSoles',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Cuenta $',
            field: 'cuentaDolares',
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'CCI Cuenta $',
            field: 'cciCuentaDolares',
            filter: 'agTextColumnFilter',
        }
    ], []);

    const agGridCuentasRecaudadorasList = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            floatingFilter: true,
            enableRowGroup: true
        },
        columnDefs: headerListaCuentasRecaudadoras,
        rowData: dataCuentaRecaudadora?.data?.table || [],
        pagination: true,
        rowGroupPanelShow: 'always',
        autoGroupColumnDef: {
            headerName: 'Grupo',
            filter: 'agGroupColumnFilter'
        },
        autoSizeColumns: true,
    }), [headerListaCuentasRecaudadoras, dataCuentaRecaudadora?.data]);

    const formatDays = useCallback((input) => {
        const parts = input.split('_');
        const start = parts[1];
        const end = parts[2];

        let formattedStart = start;
        let formattedEnd = end;

        if (start === "mas") {
            formattedStart = "A MÁS";
        }

        if (end === "mas") {
            formattedEnd = "A MÁS";
        } else if (end === "dias") {
            formattedEnd = "DÍAS";
        }

        const formattedEndPart = formattedEnd === "A MÁS" ? formattedEnd : ` - ${formattedEnd} DÍAS`;

        return formattedStart === "A MÁS" ? formattedStart : `${formattedStart} ${formattedEndPart}`;
    }, []);

    const showStatus = useCallback((value) => {
        let content;
        if (value === 0) {
            content = <>
                <span><span className="fs-2 fw-bolder">{value}</span> Días de Atraso</span>
                <img src="../media/emoticons/smile.png" alt="" className="w-50px h-50px"></img>
            </>
        } else if (value > 0 && value <= 30) {
            content = <>
                <span className="text-warning"><span className="fs-2 fw-bolder">{value}</span> Días de Atraso</span>
                <img src="../media/emoticons/badmood.png" alt="" className="w-50px h-50px"></img>
            </>
        } else {
            content = <>
                <span className="text-primary"><span className="fs-2 fw-bolder">{value}</span> Días de Atraso</span>
                <img src="../media/emoticons/sad.png" alt="" className="w-50px h-50px"></img>
            </>
        }

        return content;
    }, [])

    return (
        <>
            <PageTitle>{title}</PageTitle>
            <div className="row">
                <div className="col-12 col-md-6 col-xl-5">
                    <div className="row">
                        <div className="col-12">
                            {dataDetalleEstadoCuenta ? (
                                <div className="card mb-4">
                                    <div className="card-body p-6 d-flex flex-column">
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Fecha</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta.data.fecha}</span>
                                            </div>
                                        </div>
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Razón Social</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta.data.razonSocial}</span>
                                            </div>
                                        </div>
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Dirección</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta.data.direccion}</span>
                                            </div>
                                        </div>
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Ejecutivo Comercial</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta.data.ejecutivoComercial}</span>
                                            </div>
                                        </div>
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Ejecutivo Cobranza</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta?.data.ejecutivoCobranza}</span>
                                            </div>
                                        </div>
                                        <div className="row border-bottom py-1">
                                            <label className="col-12 col-sm-3 col-md-5 col-lg-12 fw-bold text-muted">Condición de pago</label>
                                            <div className="col-12 col-sm-9 col-md-7 col-lg-12">
                                                <span className="fs-7 text-dark">{dataDetalleEstadoCuenta.data.condicionPago}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}

                        </div>
                        <div className="col-12">
                            <div className="card mb-4">
                                <div className="card-header border-0 pt-5">
                                    <h3 className="card-title align-items-start flex-column">
                                        <span className="fw-bolder mb-2 text-dark">Lista de Contratos</span>
                                    </h3>
                                </div>
                                <div className="card-body px-6 pb-6 pt-0">
                                    <WrappedAgTable
                                        titleExcel={"listado_de_contratos"}
                                        {...agGridCobranzaList}
                                    >
                                    </WrappedAgTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-7">
                    <div className="card mb-4 h-100">
                        {deudasVencidasList?.data?.auxData ? (
                            <div className="card-body p-6 d-flex flex-column gap-3">
                                <h5>Total por cobrar</h5>

                                <div className="row">
                                    <div className="col-6 d-flex flex-column gap-1">
                                        <span className="fs-2 fw-bolder">S/ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.soles.total, true)}</span>
                                        <span className="text-primary">Vencidas S/ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.soles.vencidas, true)}</span>
                                        <span className="text-info">No Vencidas S/ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.soles.noVencidas, true)}</span>
                                        <ProgressBar
                                            animated
                                            now={deudasVencidasList.data.auxData.cobranza.soles.vencidasPorcentaje}
                                            label={`${deudasVencidasList.data.auxData.cobranza.soles.vencidasPorcentaje} %`}
                                            variant="primary" />
                                    </div>
                                    <div className="col-6 d-flex flex-column gap-1">
                                        <span className="fs-2 fw-bolder">$ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.dolares.total, true)}</span>
                                        <span className="text-primary">Vencidas $ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.dolares.vencidas, true)}</span>
                                        <span className="text-info">No Vencidas $ {Utilities.comillasFix(deudasVencidasList.data.auxData.cobranza.dolares.noVencidas, true)}</span>
                                        <ProgressBar
                                            animated
                                            now={deudasVencidasList.data.auxData.cobranza.dolares.vencidasPorcentaje}
                                            label={`${deudasVencidasList.data.auxData.cobranza.dolares.vencidasPorcentaje}`}
                                            variant="info" />
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-6 d-flex flex-column align-items-center text-center py-14">
                                        <span className="fs-4">Factura más atrasada</span>
                                        {showStatus(deudasVencidasList.data.auxData.diasFechaMasAntigua)}
                                    </div>
                                    <div className="col-6 text-center">
                                        <span className="d-block mb-3 fs-4">Tramo de Antiguedad</span>

                                        {Object.keys(deudasVencidasList.data.auxData.cobranza.tramoAntiguedad).map((key) => (
                                            <div className="row border p-2">
                                                <div className="col-12 pb-1 text-center">
                                                    <span>{formatDays(key)}</span>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span>S/ {deudasVencidasList.data.auxData.cobranza.tramoAntiguedad[key].soles}</span>
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span>$ {deudasVencidasList.data.auxData.cobranza.tramoAntiguedad[key].dolares}</span>
                                                </div>
                                            </div>
                                        ))}



                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card-body p-6 d-flex flex-column gap-3">
                                <h5>Total por cobrar</h5>

                                <div className="row">
                                    <div className="col-6 d-flex flex-column gap-1">
                                        <span className="fs-2 fw-bolder">S/ </span>
                                        <span className="text-primary">Vencidas S/ </span>
                                        <span className="text-info">No Vencidas S/ </span>
                                        <ProgressBar
                                            animated
                                            now={0} />
                                    </div>
                                    <div className="col-6 d-flex flex-column gap-1">
                                        <span className="fs-2 fw-bolder">$ </span>
                                        <span className="text-primary">Vencidas $ </span>
                                        <span className="text-info">No Vencidas $ </span>
                                        <ProgressBar
                                            animated
                                            now={0}
                                            variant="info" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-6 d-flex flex-column align-items-center text-center py-14">
                                        <span className="fs-4">Factura más atrasada</span>
                                    </div>
                                    <div className="col-6 text-center">
                                        <span className="d-block mb-3 fs-4">Tramo de Antiguedad</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>

            </div>
            <div className="row">
                <div className="card my-5">
                    <div className="card-header border-0 pt-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="fw-bolder mb-2 text-dark">Lista de Deudas Vencidas</span>
                        </h3>
                    </div>
                    <div className='card-body tab-content pt-0'>
                        <WrappedAgTable
                            titleExcel={"listado_de_deudas_vencidas"}
                            {...agGridDeudasVencidasList} >
                        </WrappedAgTable>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card my-5">
                    <div className="card-header border-0 pt-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="fw-bolder mb-2 text-dark">Lista de Cuentas Recaudadoras</span>
                        </h3>
                    </div>
                    <div className='card-body tab-content pt-0'>
                        <WrappedAgTable
                            titleExcel={"listado_de_cuentas_recaudadoras"}
                            {...agGridCuentasRecaudadorasList} >
                        </WrappedAgTable>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card my-5">
                    <div className="card-header border-0 pt-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="fw-bolder mb-2 text-dark">Garantías</span>
                        </h3>
                    </div>
                    <div className='card-body tab-content pt-0'>
                        <WrappedAgTable
                            titleExcel={"Garantías"}
                            {...agGridListaGarantiasByEstadoCuenta} >
                        </WrappedAgTable>
                    </div>
                </div>
            </div>
            {showDetalleDeuda && <DetalleDeuda setShowDetalleDeuda={setShowDetalleDeuda} idDeuda={idDeudaCurrentDetalle}></DetalleDeuda>}
        </>
    )
}


